<template>
    <a-modal
      :title="title"
      :width="860"
      :visible="visible"
      ok-text="确定"
      cancel-text="取消"
      @ok="
        () => {
          $emit('ok');
        }
      "
      @cancel="
        () => {
          $emit('cancel');
        }
      "
    >
      <a-spin :spinning="loading">
        <a-form :form="form" v-bind="formLayout">
          <a-form-item label="资源库名称">
            <a-input
              v-decorator="[
                'name',
                { rules: [{ required: true, message: '请输入资源库名称' }] },
              ]"
            />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </template>
  
  <script>
  import pick from "lodash.pick";
  import { requestUrl } from "@/utils/request_url";
  const fields = ["name"];
  export default {
    name: "ResourceForm",
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      model: {
        type: Object,
        default: () => {},
      },
      title: {
        type: String,
        default: "新增资源库",
      },
      visible: {
        type: Boolean,
        required: true,
      },
      
    },
    data() {
      this.formLayout = {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 13 },
        },
      };
      return {
        form: this.$form.createForm(this),
        headers: {},
      
      };
    },
    created() {
      fields.forEach((v) => this.form.getFieldDecorator(v));
      this.$watch("imageUrl", () => {
       // this.imageUrl2 = this.imageUrl.url;
      });
      this.$watch("model", () => {
        this.model && this.form.setFieldsValue(pick(this.model, fields));
      });
    },
   
    computed: {
     
    },
    mounted() {},
    methods: {
     
    },
  };
  </script>
  <style lang="scss" scoped>
  .box{
    border: 1px dashed #ccc;
    padding: 10px;
    justify-content: space-around;
    justify-content: flex-end;
  }
  </style>
  